/**
 * Locale fonts: loaded in <head> via public/locale-fonts-init.js on first paint.
 * This module covers client-side locale switches after React has mounted.
 */

import { setDocumentLocale } from "./setDocumentLocale";

const LOCALE_STYLESHEETS = {
  ja: '/fonts/locale/ja.css',
  ko: '/fonts/locale/ko.css',
  zh: '/fonts/locale/zh.css',
};

function ensureStylesheet(href) {
  if (document.querySelector(`link[data-locale-fonts="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.setAttribute('data-locale-fonts', href);
  document.head.appendChild(link);
}

export function loadLocaleFonts(locale) {
  setDocumentLocale(locale);

  const href = LOCALE_STYLESHEETS[locale];
  if (href) ensureStylesheet(href);

  return Promise.resolve();
}
